import { useRef, useEffect } from "react";
import Head from "next/head";

const WinBackRefunds = () => {
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleMessage = (event) => {
            const { iframeHeight, isResize } = event.data;
            if (iframeHeight && iframeRef.current) {
                console.log(iframeHeight, iframeRef.current.style.height, "outsideOfIf")
                if(!isResize && iframeHeight) {
                    console.log(iframeRef.current.style.height, "insideOfIf")
                    iframeRef.current.style.height = `${iframeHeight - 60}px`;
                }

                if(iframeHeight && isResize){
                    iframeRef.current.style.height = `${iframeHeight - 60}px`;
                }

            }

        };



        window.addEventListener("message", handleMessage);


        return () => {
            window.removeEventListener("message", handleMessage);
        };

    }, []);
    return (
        <>
            <Head>
                <title>Win Back Refunds Add-On by Apphud</title>
                <link rel="canonical" href="https://apphud.com/flows"/>
                <meta
                    property="og:title"
                    content="A complete suite to launch mobile web-to-web campaigns – Apphud Flows"
                />
                <meta
                    property="og:description"
                    content="Streamline your refund management with automated responses to Apple’s App Store refund requests, protecting your revenue and enhancing customer experience."
                />
                <meta name="keywords" content="refund management, App Store refunds"/>
                <meta property="og:url" content="https://apphud.com/win-back-refunds"/>
                <meta name="framer-search-index"
                      content="https://framerusercontent.com/sites/73sGyR0TS95qw2qNwVO5Cm/searchIndex-yMuk0gDuvF4I.json"/>
                <meta name="framer-html-plugin" content="disable"/>
                <link href="https://framerusercontent.com/images/9pZXEnTZ9NBFmdZokUTtOq67iis.png" rel="icon"
                      media="(prefers-color-scheme: light)"/>
                <link href="https://framerusercontent.com/images/9pZXEnTZ9NBFmdZokUTtOq67iis.png" rel="icon"
                      media="(prefers-color-scheme: dark)"/>
                <meta name="robots" content="noindex"/>
                <link rel="canonical" href="https://l.apphud.com/win-back-refunds"/>
                <meta property="og:url" content="https://l.apphud.com/win-back-refunds"/>

            </Head>

            <iframe
                ref={iframeRef}
                // src="https://l.apphud.com/flows"
                src="https://minimum-try-538256.framer.app/winback-refunds"
                style={{
                    width: "100%",
                    // height: "100%",
                    border: "none",
                    overflow: "hidden",
                }}
            ></iframe>

        </>


    );
};

export default WinBackRefunds;


